import {Card} from 'platform/components';
import {Heading, VStack} from 'platform/foundation';

import {isEmpty, isNil} from 'ramda';

import i18n from '@dms/i18n';

import {Nullish, RequiredTestIdProps} from 'shared/web';

import {DescriptionText} from './DescriptionText';

interface DescriptionCardProps extends RequiredTestIdProps {
  description: string | Nullish;
}

/** The seller's own text, set apart as a quote; line breaks of the ad are kept. */
export function DescriptionCard(props: DescriptionCardProps) {
  if (isNil(props.description) || isEmpty(props.description.trim())) {
    return null;
  }

  return (
    <Card>
      <VStack spacing={3}>
        <Heading size={4}>
          {i18n.t('entity.sourcing.vehiclePreview.labels.vehicleDescription')}
        </Heading>
        {/* A new description remounts the text, so the clamp is measured on its element again. */}
        <DescriptionText
          key={props.description}
          description={props.description}
          data-testid={props['data-testid']}
        />
      </VStack>
    </Card>
  );
}
